import { buildClientSchema } from 'graphql';

const buildClientSchemaFromIntrospection = (schema) => {
  if (!schema) {
    return null;
  }

  return buildClientSchema({ __schema: schema });
};

export default buildClientSchemaFromIntrospection;
